export default "__VITE_ASSET__BHh0_ts7__"